module.exports = __webpack_public_path__ + "static/resources_links-5631f9cdb2b2d158fab4c253e8077f04.jpg";